export class BreadcrumbItem {
    link: string;
    name: string;
    constructor(link: string, name: string) {
        this.link = link;
        this.name = name;
    }
}